import PageHeader from '@/views/global/pageHeader/pageHeader.component.vue'
import Carousel from '@/views/global/carousel/carousel.component.vue'
import PageFooter from '@/views/global/pageFooter/pageFooter.component.vue'

export default {
  name: 'Frame',
  data () {
    return {
    }
  },
  components: {
    PageHeader,
    Carousel,
    PageFooter
  }
}



// WEBPACK FOOTER //
// ./src/views/global/frame/frame.component.js